import api from '../api/axios';

const getAll = (withDeleted = false) => {
  return api.get('/equipment-types', { params: { withDeleted } });
};

const getById = (id) => {
  return api.get(`/equipment-types/${id}`);
};

const create = (item) => {
  return api.post('/equipment-types', item);
};

const update = (id, data) => {
  return api.patch(`/equipment-types/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/equipment-types/${id}`);
};

const restore = (id) => {
  return api.get(`/equipment-types/${id}/restore`);
};

const equipmentTypesServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  restore,
};

export default equipmentTypesServices;

